

















import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'

Vue.mixin(ScrollFire)

export default
  created: () ->
    @$options.scroll_target = '.first_view'
  data: () ->
    fire_scroll: true
  methods: {
    scrollFire: (e) ->
      @$emit('scrollFire')
  }
